import BvText from 'volta/components/bv-text';
import TasksKitList from 'volta/components/tasks-kit/list';
import isTrue from 'volta/helpers/is-true';

import type { TOC } from '@ember/component/template-only';
import type { TCommonListArgs } from 'volta/components/tasks-kit/list';
import type { IResourceName } from 'volta/models/base-model';

export interface TasksKitListDateSignature {
  Args: TCommonListArgs & {
    onLightBg?: boolean;
  };
}

const TasksKitListDateComponent: TOC<TasksKitListDateSignature> = <template>
  <TasksKitList
    @isLoading={{@isLoading}}
    @entityResourceName={{@entityResourceName}}
    @dueDateIdPrefix={{@dueDateIdPrefix}}
    @tasks={{@tasks}}
    @selectedTask={{@selectedTask}}
    @onSubmit={{@onSubmit}}
    @onResolve={{@onResolve}}
    @onDelete={{@onDelete}}
    @onDraft={{@onDraft}}
    @onSelect={{@onSelect}}
    @isAutoResolvable={{@isAutoResolvable}}
    @selectedView={{@selectedView}}
    @taskType={{@taskType}}
    @newDisabled={{@newDisabled}}
    @readonlyTasks={{@readonlyTasks}}
    @hideAddButton={{@hideAddButton}}
    @authorizedUsers={{@authorizedUsers}}
    @onLightBg={{@onLightBg}}
    as |date|
  >
    <div
      class='bv-task-group-divider {{if (isTrue @selectedTask) "bv-task-group-divider--selected"}}'
    >
      <BvText
        @as='h3'
        @variant='heading-xs'
        @text={{date}}
        class='bv-task-group-title u-text-upper'
      />
    </div>
  </TasksKitList>
</template>;

export default TasksKitListDateComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::Date': typeof TasksKitListDateComponent;
    'tasks-kit/list/date': typeof TasksKitListDateComponent;
  }
}
